import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const JourneySVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default JourneySVG;
